/** Human countdown to an SLA deadline.
 *  Returns {text, tone}. Paused tickets show no countdown at all: the clock is
 *  stopped, so a ticking number would be a lie. */
export function slaCountdown(ticket, statusRow) {
  if (!ticket?.sla_deadline) return { text: "—", tone: "muted" };
  if (statusRow?.closes_ticket) {
    return ticket.sla_breached
      ? { text: "Breached", tone: "danger" }
      : { text: "Met", tone: "success" };
  }
  if (statusRow?.pauses_sla) return { text: "Paused", tone: "muted" };
  const ms = new Date(ticket.sla_deadline).getTime() - Date.now();
  if (Number.isNaN(ms)) return { text: "—", tone: "muted" };
  if (ms <= 0) return { text: "Breached", tone: "danger" };
  const mins = Math.floor(ms / 60000);
  const text = mins < 60 ? `${mins}m`
    : mins < 60 * 24 ? `${Math.floor(mins / 60)}h ${mins % 60}m`
    : `${Math.floor(mins / 1440)}d`;
  return { text, tone: mins < 60 ? "warning" : "muted" };
}
